import './index.less';

/** 网站公共页脚，在登录入口与管理页面统一展示备案查询链接。 */
export default function SiteFooter() {
  return <footer className="site-footer">
    <span className="site-footer__name">网站备案</span>
    <a className="site-footer__link" href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">桂ICP备2026003750号-1</a>
  </footer>;
}
